import { responseHandleService } from './ResponseHandleService';
import AuthenticationService from './AuthenticationService';
import axios from 'axios';

export const administrativeActsInfoService = {
  getAll,
  search,
  deleteInfoDocuments
};

const requestOptions = {
  method: 'GET',
  headers: Object.assign(
    {},
    {
      Accept: 'application/json',
      'Content-type': 'application/json'
    }
  )
};

function getAll(pageNumber, archiveYear) {
  let url = `${
    process.env.REACT_APP_API_URL
  }/api/administrative_acts_informations/?page[number]=${
    pageNumber ? pageNumber : 1
  }`;

  if (archiveYear && archiveYear !== 'all') {
    url = `${url}&archiveYear=${archiveYear}`;
  }

  return fetch(url, requestOptions).then(responseHandleService.handleResponse);
}

function search(searchInfoDocument, pageNumber) {
  let searchUrl = `${
    process.env.REACT_APP_API_URL
  }/api/administrative_acts_informations/search?title=${
    searchInfoDocument.title
  }&page[number]=${pageNumber ? pageNumber : 1}`;

  return fetch(searchUrl, requestOptions).then(
    responseHandleService.handleResponse
  );
}

function deleteInfoDocuments(infoDocumentId) {
  const requestOptionsDelete = {
    headers: {
      Accept: 'application/json'
    }
  };
  this.authentication = new AuthenticationService();

  if (this.authentication.loggedIn()) {
    requestOptionsDelete.headers['Authorization'] =
      'Bearer ' + this.authentication.getToken();
  }
  let url = `${process.env.REACT_APP_API_URL}/api/administrative_acts_informations/${infoDocumentId}`;

  return axios.delete(url, requestOptionsDelete);
}
